import TopMenuHome from '../components/TopMenuHome';
import BottomMenu from '../components/BottomMenu';
import { Container, Row, Col, Image, Button } from 'react-bootstrap'
//import TempImage from '../images/htt500x500.png';
import httwhite from '../images/httwhite.png';
import isuzulogo from '../images/isuzulogo.jpg';
//import mcneiluslogo from '../images/mcneiluslogo.jpg';
import peterbiltlogo from '../images/peterbiltlogo.jpg';

function OpeningPage() {
    return (
        <div>
            <TopMenuHome />
            <div className="hero-bg">
                <Container className="h-100">
                    <Row className="h-100 align-items-center">
                        <Col md={6}>
                            <Image
                                src={httwhite}
                                width={'100%'}
                            />
                        </Col>
                        <Col md={6}>
                            <h1 className="htitle">Hawaii's largest full-service heavy and medium-duty truck dealer</h1>
                            <p className="text-white">
                                Helping local businessses since 1946.
                            </p>
                            <Button>Read More</Button>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container>
              <br />
                <h2 className='htitleb text-center'>AUTHORIZED DEALERS FOR</h2>
                <Row className='justify-content-center'>
                    <Col md={4} className="justify-content-center">
                        <div id="card-box">
                            <Image
                                src={peterbiltlogo}
                                width={'100%'}
                            />
                        </div>
                    </Col>
                    <Col md={4}>    
                        <div id="card-box">
                            <Image
                                src={isuzulogo}
                                width={'100%'}
                            />
                        </div>
                    </Col>
                    
                </Row>
                <br />
            </Container>
            <BottomMenu />
        </div>
    );
}

export default OpeningPage;